<template>
  <div style="width: 100%;height: 100%">
    <viewer :images="images" style="display: none">
      <img v-for="src in images" :key="src" :src="src" class="max-image" ref="maxImage">
    </viewer>
    <transition name="router-fade" mode="out-in" v-if="$route.meta.keepAlive">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
    </transition>
    <transition name="router-fade" mode="out-in" v-else>
      <router-view v-if="!$route.meta.keepAlive" />
    </transition>
    <AskForAnInvoice v-if="$cookies.get('userInfo')" />
    <transition name="el-zoom-in-center">
      <EditAddress v-if="$cookies.get('userInfo') && getAddressModal.show" />
    </transition>
    <noticeDetail v-if="noticeDetailShow" :id="noticeDetailId" :noticeType="1" @close="noticeClose" />
  </div>
</template>

<script>
import noticeDetail from "@/components/repairFactory/noticeDetail";
import { isOpenMode, isMobile } from './router/deviceCheck';
import { mapActions, mapGetters, mapMutations } from "vuex";
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from "vue";
import { Message, Notification } from "element-ui";
import xkmLogo from './assets/images/xkm-logo.png';
/*import VueCookie from 'vue-cookie';
//载入cookie
Vue.use(VueCookie)*/
Vue.use(VueViewer)
import AskForAnInvoice from "./components/invoice/AskForAnInvoice";
import EditAddress from '@/components/Address/EditAddress';
import {
  getUnpaidServiceFee,
  updateUserNoticeId,
  getUserNoticeId,
} from '@/assets/request/HomeRequest.js';
import {
  pageRouteName,
} from '@/config/canNoCheckLoginInfo.js';
let thisTimeOut;
async function getChatToken({ ust = '' }) {
  const a = await this.$axios({
    url: '/Tuser/gettoken',
    method: 'post',
    params: {
      ust,
    },
    transformRequest: [data => {
      let params = "";
      for (var index in data) {
        params += index + "=" + data[index] + "&";
      }
      return params;
    }]
  });
  this.Common.setChatToken({ chatToken: a.data.data });
  return a.data;
}
async function setUserInfo() {
  if (!this.$cookies.isKey('userInfo') || !this.$cookies.get('userInfo').authkey) return;
  const userInfo = this.$cookies.get('userInfo');
  let ust = this.$cookies.get('userInfo').authkey;
  let validateToken = await getChatToken.call(this, { ust });
  validateToken = validateToken.data;
  this.Common.setIfLoad1(1);
  if (userInfo['authKey'.toLowerCase()]) {
    this.Common.setUserInfo({
      authKey: userInfo['authKey'.toLowerCase()].replace(/\+/g, "%2B") /*存储用户key*/,
      thisUserId: userInfo['fid'] /*存储用户id*/,
      loginType: userInfo['loginType'.toLowerCase()] /*存储用户类型*/,
      userPhone: userInfo['uPhone'.toLowerCase()] /*存储用户账号*/,
      // userName: validateToken['userInfo'].userName /*存储用户名*/,
      // level: validateToken['userInfo'].level /*存储公司下用户类型*/,
      // companyId: validateToken['userInfo'].companyId /*存储公司id*/,
    });
    await getChatToken.call(this, { ust: this.Common.authKey }).then(() => {
      this.Common.setIfLoad2(1);
    });
  } else await this.$router.replace({ name: "login" });
}
function fromMessageAudio() {
  document.documentElement.onclick = function () {
    // /music/jn398.mp3
    new Audio("/v2-front/static/inquiryIsHere.mp3").play();
    document.documentElement.onclick = null;
  };
  document.documentElement.click();
}
export default {
  name: "App",
  data: () => ({
    timeout: 1000, //每秒发送心跳
    severTimeout: 5000, //服务端超时时间
    timeoutObj: null,
    serverTimeoutObj: null,
    lockReconnect: false /*避免重复连接*/,
    $wsServer: null,
    images: [],
    noticeDetailShow: false,
    noticeDetailId: null,
  }),
  computed: {
    //device: () => isOpenMode() === 2?'pcWeChat':isMobile()?'mob':typeof this.$cookies!=='undefined' && typeof this.$cookies.get('userInfo')!=='undefined' && typeof this.$cookies.get('userInfo').from !=='undefined' ?'backEnd':'pc',
    ...mapGetters([
      'homeNoticeGetter',
      "getConnectionStatePrompt", "getChatList", "getConnectionIsRepeat", "getPCChatState", "getAddressModal"]),
  },
  watch: {
    images(images) {
      setTimeout(() => {
        images.length < 2 && images.length > 0 && this.$refs.maxImage[0].click()
      })
    },
    $route(to) {
      if (pageRouteName.includes(to.name)) return
      this.checkNewNotice()
    },
  },
  created() {
    this.loadListAction({
      callback: () => {
        this.checkNewNotice()
      }
    });
    setUserInfo.call(this);
    if (this.$cookies.isKey('userInfo')) {
      this.getAddress();
      this.getInvoiceListRequest();
    }

    this.setValue();
    this.initWebSocket();
  },
  methods: {
    /**
     * 检查接受到的最新的通知
     */
    async checkNewNotice() {
      const listData = this.homeNoticeGetter
      if (!listData || !listData.length) return
      const newNoticeId = listData[0]['Id']
      /** 上次读取到的最新id */
      const bestNewNoticeId = await new Promise((resolve,) => {
        getUserNoticeId().then(res => {
          if (res.data && res.data.data) {
            resolve(res.data.data.notice_id)
          }
        })
      })
      /** 最新的读取过则返回不再展示 */
      /* = Number(newNoticeId) */
      if (Number(bestNewNoticeId) <= 0) return;
      const aWeekMillisecond = 7 * 24 * 60 * 60 * 1000; /** 一周的毫秒数 */
      const isNoMoreOneWeek = new Date() - new Date(listData[0]['ctime']) < aWeekMillisecond /** 不大于一周 */
      /** 大于一周则不再展示 */
      if (!isNoMoreOneWeek) return;
      updateUserNoticeId({
        notice_id: newNoticeId,
      }).then(res => {
        if (Number(res.data.code) !== 200) return Message.warning(res.data.msg)
        this.noticeOpen(newNoticeId)
      })
    },
    noticeOpen(id) {
      this.$data.noticeDetailShow = true
      this.$data.noticeDetailId = Number(id)
    },
    noticeClose() {
      this.$data.noticeDetailShow = false
      this.$data.noticeDetailId = null
    },
    refreshRoute({ callback, to, from, }) {
      if (to.path === from.path && to.fullPath !== from.fullPath) {
        toString.call(callback) === '[object Function]' && callback()
      }
    },
    async getUnpaidServiceFeeRun() {
      if (!this.$cookies.isKey('userInfo')) return
      const { data: res } = await getUnpaidServiceFee().catch(r => console.log(r))
      if (!res) return
      if (res.code == 1) {
        const r = Notification({
          title: "有未支付佣金",
          message: `您当前有未支付佣金，请前去支付`,
          duration: 0,
          onClick: () => {
            this.changeTab({
              componentName: 'sale'
            })
            r.close();
          }
        });
        return
      }
      if (res.code == 3) this.$router.replace({
        name: 'fullSale'
      })
    },
    ...mapMutations(['changeTab', "editGlobalEditAddressShow", "writeAllRoomList", "loadMoreChatListInfoSelect1st", "loadMoreChatListInfo", "updateConnectionStatePrompt", "chatListInfoHaveParam", "edit", "updateRepeatLogin", "updateChatDetail", "chatListInfo", "updateSelectedInfo", "updatePCChatState", "updateRepeatLoginPrompt", "chatListInfoSelect1st",]),
    ...mapActions(['quotePriceListApiAction', "receivingChatAsync", "getAddress", "getInvoiceListRequest", "getUserInfoAction", 'loadListAction']),
    receivedNewInquiry({ Model, inquiryId, inquiryUser }) {
      fromMessageAudio();
      const r = Notification({
        dangerouslyUseHTMLString: true,
        title: "询价单来了",
        message: `<div style="font-size:13px;cursor:pointer;">
          <p style="display:flex;"><b style="min-width:70px;">询价单号：</b> <span>${inquiryId}</span> </p>
          <p style="display:flex;"><b style="min-width:70px;">询价人：</b> <span>${inquiryUser}</span> </p>
          <p style="display:flex;"><b style="min-width:70px;">车型：</b> <span>${Model}</span> </p>
          <p style="text-align:right;"><b style="color:var(--JN_mainColor)">去报价&gt;&gt;</b></p>
          </div>`,
        duration: 5000,
        onClick: () => {
          this.seeDetailQuotePage({ inquiryId });
          this.$store.commit('UnReadMessage/changeHadRead', {
            inquiryId,
          })
          r.close();
        }
      });
      this.$store.commit('UnReadMessage/unshiftList', {
        Model, inquiryId, inquiryUser
      })
      this.$store.state.openedTab.includes('queryPriceList') && this.quotePriceListApiAction();
    },
    seeDetailQuotePage({ inquiryId }) {
      this.changeTab({
        componentName: 'jnquotedetail',
        refresh: true,
        params: {
          id: inquiryId,
        },
      });
    },
    image(arr = []) {
      if (!arr || !arr.length) return;
      this.images = arr;
    },
    initWebSocket() {
      if (!this.$cookies.get('userInfo') || !this.$cookies.get('userInfo').authkey) return;
      if (this.$wsServer && this.$wsServer.readyState === WebSocket.OPEN) return
      try {
        const wsProtocol = location.protocol.includes('https') ? 'wss' : 'ws'
        this.$wsServer = new WebSocket(process.env.NODE_ENV === 'development' ? `${wsProtocol}://xkm.51qpb.com/websocket/` : `${wsProtocol}://www.xinkameng.com/websocket/`);
      } catch (e) {
        console.group();
        console.log(e);
        console.groupEnd()
        this.repeatConnection();
        return;
      }
      this.$store.commit('changeState', {
        websocketConnectStatus: true,
      });
      this.$wsServer.onmessage = this.webSocketOnMessage;
      this.$wsServer.onopen = this.webSocketOnOpen;
      this.$wsServer.onerror = this.webSocketOnError;
      this.$wsServer.onclose = this.webSocketOnClose;
    },
    repeatConnection() {
      this.$store.commit('changeState', {
        websocketConnectStatus: false,
      })
      if (this.getConnectionStatePrompt !== "正在重连中...") this.updateConnectionStatePrompt({ value: "正在重连中..." });
      if (this.lockReconnect) return;
      this.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      thisTimeOut && clearTimeout(thisTimeOut);
      if (this.getConnectionIsRepeat) return;
      thisTimeOut = setTimeout(() => {
        this.initWebSocket();
        this.lockReconnect = false;
      }, 2000);
    },
    websocketRepeatLogin(e, { offlineConfirm = '' }) {
      this.updateConnectionStatePrompt({ value: offlineConfirm + "，点击重连" });
      this.updateRepeatLogin(true);
      this.updateRepeatLoginPrompt(offlineConfirm);
    },
    webSocketOnMessage(e) {
      if (e.data !== 1) {
        let res = JSON.parse(e.data);
        switch (res.type) {
          /*重复登录（这个是登录过，又在其他地方登录，原登录的会传这个）*/
          case "repeatLogin": this.websocketRepeatLogin(null, { offlineConfirm: res.msg, }); break;
          /*滚动条到顶部，加载历史记录*/
          // case "loadMore": this.scrollTopLoadMore(null,{chatData:res.data.map(item=>JSON.parse(item).data),}); break;
          /*房间号信息*/
          // case "roomList":this.initialLoadRoomList(null,{roomListData: res.data});break;
          /*第一次进入房间，请求的历史记录*/
          // case "historyMsg":this.scrollTopLoadMore(null,{chatData:res.data.map(item=>JSON.parse(item).data),});break;
          /*新消息*/
          // case "msg": this.receivedNewChat(null,{messageData:res.data,}); break;
          /*新询价通知*/
          case "newInquirySheet": this.receivedNewInquiry(res.msg); break;
          case "error": this.$wsServer.close(); break;
          case "wxbinding":
            this.getUserInfoAction();
            /*Array.from(document.getElementsByTagName('iframe')).forEach(i=>{
              i.src.toLowerCase().indexOf('/ucenter/uc')>=0 && i.contentWindow.checkWeixin();
            })*/

            break;
          case 'zfCallBackNotice':
            Message.success(res.msg);
            Array.from(frames).forEach((i, index) => {
              if (i.name === "factoryOrder" || i.name === "cjOrderList" || i.name === "factoryOrderDetail")
                frames[index].location.reload();
            });
            // 刷新下单列表和提示付款成功
            break;
        }
      }
      this.webSocketHeartbeat();
    },
    webSocketOnOpen() {
      const str = { op: "login", data: this.Common.chatToken };
      this.device = isOpenMode() === 2 ? 'pcWeChat' : isMobile() ? 'mob' : typeof this.$cookies !== 'undefined' && typeof this.$cookies.get('userInfo') !== 'undefined' && typeof this.$cookies.get('userInfo').from !== 'undefined' && this.$cookies.get('userInfo').from == 'backEnd' ? 'backEnd' : 'pc';
      str.data["client"] = this.device;
      let deviceCheck = {
        pc: () => {
          this.webSocketSend(JSON.stringify(str));
          this.updateRepeatLogin(false);
          this.updatePCChatState(true);
        },
        mob: () => {
          this.webSocketSend(JSON.stringify(str));
          this.updateRepeatLogin(false);
          this.updatePCChatState(false);
        },
        pcWeChat: () => {
          this.webSocketSend(JSON.stringify(str));
          this.updateRepeatLogin(false);
          this.updatePCChatState(false);
        },
        backEnd: () => {
          this.webSocketSend(JSON.stringify(str));
          this.updateRepeatLogin(false);
          this.updatePCChatState(true);
        },
        true: () => {
          alert("啥端也不是");
        },
      };
      deviceCheck[Object.keys(deviceCheck).find((item) => this.device === item)]();
    },
    webSocketOnError() {
      console.log("websocket error: ---------------");
      this.repeatConnection();
    },
    webSocketOnClose() {
      !this.getConnectionIsRepeat && this.repeatConnection();
    },
    webSocketSend(data) {
      if (JSON.parse(data).op === "login" || this.getConnectionStatePrompt == "") {
        this.$wsServer.send(data);
      }
    },
    webSocketHeartbeat() {
      this.timeoutObj && clearTimeout(this.timeoutObj);
      this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
      if (this.getPCChatState.isRepeatLogin) return;
      this.timeoutObj = setTimeout(() => {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常
        if (this.$wsServer.readyState === WebSocket.OPEN) this.$wsServer.send("check"); // 心跳包
        //计算答复的超时时间
        this.serverTimeoutObj = setTimeout(() => {
          if (this.$cookies.get('userInfo') && !String(this.$cookies.get('userInfo').authkey)) return clearTimeout(this.serverTimeoutObj);
          // confirm("网络波动，自动重连失败，请点击确定再次自动重连") && location.reload();
        }, this.severTimeout);
      }, this.timeout);
    },
    async setValue() {
      const rootElement = document.querySelector(':root');
      const res = await this.$axios.get("/appapi/websitestyle/basecss").catch(r => {
        console.log(r);
      })
      if (!res) {
        rootElement.style.setProperty('--JN_mainColor', 'red');
        rootElement.style.setProperty('--JN_secondColor', 'red');
        this.$store.commit("edit", {
          logo: xkmLogo,
          mainColor: 'red',
          secondColor: 'red',
          companyName: '',
        });
        return;
      }
      const resData = res.data;
      this.$store.commit("edit", res.data);
      rootElement.style.setProperty('--JN_mainColor', resData.mainColor);
      rootElement.style.setProperty('--JN_secondColor', resData.secondColor);
      // this.JNCommon.setValue(res.data);
      // const {href} = this.$router.resolve({ path: '/'});
      //       window.open(href, '_self');
      // this.$router.push({path: '/login'});
    },
  },
  components: {
    AskForAnInvoice,
    EditAddress,
    noticeDetail,
  },
};
</script>
<style lang="scss">
:root {
  --JN_mainColor: transparent;
  --JN_secondColor: transparent;
  --copyRightBackgroundColor: #585858;
}

.el-input__inner {
  &:focus {
    border-color: var(--JN_mainColor);
  }
}

.el-select .el-input__inner:focus {
  border-color: var(--JN_mainColor);
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: var(--JN_mainColor);
  background-color: var(--JN_mainColor);
}

.el-radio__input.is-checked+.el-radio__label {
  color: var(--JN_mainColor);
}

.el-textarea__inner:focus {
  border-color: var(--JN_mainColor);
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--JN_mainColor)
}

.el-select-dropdown__item.selected {
  color: var(--JN_mainColor);
}

.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: var(--JN_mainColor);
}

.el-pager li.active,
.el-pager li:hover {
  color: var(--JN_mainColor);
}

.el-pagination button:hover {
  color: var(--JN_mainColor);
}

.el-checkbox__inner:hover {
  border-color: var(--JN_mainColor);
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--JN_mainColor);
  border-color: var(--JN_mainColor);
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--JN_mainColor);
}

.el-checkbox__input {
  &.is-focus {
    border-color: var(--JN_mainColor);
  }
}
</style>
<style scoped lang="scss">
@import 'style/common';

.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity .3s;
}

.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}
</style>
